import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { schedulesClassesPropTypes, schedulesInstructorsPropTypes, msiLastChangePropTypes } from 'constants/propTypes';
import LoadingDots from 'components/LoadingDots';
import Message from 'components/Message';
import Button from 'components/Button';
import LastUpdate from 'components/LastUpdate';
import { DateInput, Input, TimePicker, InputLabel, ButtonGroup } from 'components/Form';
import { Card, CardSection } from 'components/Card';
import { BackNavLink, Title } from 'features/App';
import { SelectInstructorInput, SelectClassInput, CapacityInput } from '../ScheduleFormInputs';
import messages from '../ScheduleForm.messages';

const EditScheduleInstanceForm = ({
  classTitle,
  classes,
  handleSubmit,
  instructors,
  isLoading,
  onSave,
  updateStartDate,
  lastChange,
}) => {
  if (isLoading) {
    return (
      <div>
        <LoadingDots centered />
      </div>
    );
  }

  return (
    <>
      <BackNavLink useHistoryHook />
      <Title>{classTitle}</Title>
      <Card flush>
        <CardSection>
          <div className="grid">
            <div className="grid__item lg-1/2">
              <div className="grid">
                <div className="grid__item md-1/2 pt-s" data-cypress="start-date-input">
                  <InputLabel message={messages.date} />
                  <Field name="startDate" disabled component={DateInput} />
                </div>
                <div className="grid__item pt-l">
                  <div className="grid">
                    <div className="grid__item md-1/2" data-cypress="start-time-input">
                      <InputLabel message={messages.startTime} />
                      <Field name="startTime" component={TimePicker} disabled />
                    </div>
                    <div className="grid__item md-1/2" data-cypress="duration-input">
                      <InputLabel message={messages.duration} />
                      <Field
                        parse={value => value && Number(value)}
                        name="durationInMinutes"
                        type="number"
                        component={Input}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid__item lg-1/2">
              <div className="grid">
                <div className="grid__item pt-l" data-cypress="class-input">
                  <InputLabel message={messages.class} />
                  <Field name="classId" component={SelectClassInput} classes={classes} disabled />
                </div>
                <div className="grid__item pt-l" data-cypress="instructor-input">
                  <InputLabel message={messages.instructor} optional />
                  <Field name="instructorId" component={SelectInstructorInput} instructors={instructors} />
                </div>
                <div className="grid__item 1/2 pt-l" data-cypress="capacity-input">
                  <InputLabel message={messages.capacity} />
                  <Field name="capacity" component={CapacityInput} disabled />
                </div>
              </div>
            </div>
          </div>
        </CardSection>
        <ButtonGroup>
          <Message
            as={Button}
            onClick={updateStartDate}
            styled="tertiary"
            className="md-mr-auto"
            message={messages.footer.discardChanges}
          />
          <LastUpdate {...lastChange} />
          <Message as={Button} styled="primary" onClick={handleSubmit(onSave)} message={messages.footer.save} />
        </ButtonGroup>
      </Card>
    </>
  );
};

EditScheduleInstanceForm.propTypes = {
  classTitle: PropTypes.string,
  classes: schedulesClassesPropTypes,
  handleSubmit: PropTypes.func,
  initialSpots: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  instructors: schedulesInstructorsPropTypes,
  isLoading: PropTypes.bool,
  onSave: PropTypes.func,
  updateStartDate: PropTypes.func,
  lastChange: msiLastChangePropTypes,
};

export default EditScheduleInstanceForm;
